import React from "react";
import { Container } from "reactstrap";


const Monitoring = () => (
  <Container fluid className="p-0">
    <div> Monitoring </div>
  </Container>
);

export default Monitoring;
